$(function() {
  $('a[href="#"]').on("click", function() {
    return false
  })
})
